/* HMX V53 MODEL DROPDOWN HARDFIX — restores native long model/device dropdowns after legacy catalog normalization. */
(function(){
'use strict';
if(window.__HMX_V53_MODEL_DROPDOWN_HARDFIX__)return;
window.__HMX_V53_MODEL_DROPDOWN_HARDFIX__=true;
var D=document;
function norm(v){return String(v||'').replace(/\s+/g,' ').trim();}
function modelSelect(group){
  var s=group&&group.querySelector('select[name]');
  if(!s||s.options.length<8)return null;
  var key=String(s.name||'').toLowerCase();
  if(!/(model|device|phone|iphone|samsung|galaxy)/i.test(key))return null;
  return s;
}
function cleanLabel(group,s){
  var lab=group.querySelector('.form__label');if(!lab)return;
  var values=Array.prototype.slice.call(s.options).map(function(o){return norm(o.value||o.textContent);}).join(' ').toLowerCase();
  if(values.indexOf('samsung')!==-1||values.indexOf('galaxy')!==-1)lab.textContent='Choose Your Samsung Model';
  else if(values.indexOf('iphone')!==-1)lab.textContent='Choose Your iPhone Model';
  else lab.textContent='Choose Your Model';
}
function fixGroup(group){
  var s=modelSelect(group);if(!s)return;
  group.querySelectorAll('.hmx-r15-color-pills').forEach(function(n){n.remove();});
  group.querySelectorAll('.hmx-r15-color-source').forEach(function(n){n.classList.remove('hmx-r15-color-source');});
  group.dataset.hmxR15Color='1';
  group.dataset.hmxV53Dropdown='1';
  group.setAttribute('data-hmx-v53-native-model-dropdown','true');
  group.classList.remove('hmx-v53-color-group');
  group.classList.add('hmx-v53-full-dropdown','hmx-v53-model-dropdown','product-form__input--dropdown','product-form__input--full');
  s.setAttribute('data-hmx-v53-native-model-select','true');
  var wrap=s.closest('.select')||s.parentElement;if(wrap){wrap.classList.remove('hmx-r15-color-source');wrap.classList.add('hmx-v53-native-model-select');}
  cleanLabel(group,s);
}
function fix(){
  if(location.pathname.indexOf('/products/')===-1)return;
  D.querySelectorAll('#MainContent variant-selects .product-form__input,#MainContent variant-radios .product-form__input').forEach(fixGroup);
}
function schedule(){fix();setTimeout(fix,0);setTimeout(fix,80);setTimeout(fix,300);}
if(D.readyState==='loading')D.addEventListener('DOMContentLoaded',schedule,{once:true});else schedule();
D.addEventListener('shopify:section:load',schedule);
D.addEventListener('change',function(e){if(!e.target||!e.target.closest||!e.target.closest('#MainContent variant-selects,#MainContent variant-radios'))return;setTimeout(fix,0);setTimeout(fix,100);});
})();
